import React from 'react'
import {withStyles, CircularProgress, Paper, TextField, Button, FormControl, InputLabel, Select, MenuItem} from '@material-ui/core'
import {Send} from '@material-ui/icons'
import {grey} from '@material-ui/core/colors'

import { getAssetModelServiceByIdProvider, getAssetModelProvider, getSystemProvider, updateAssetModelServiceProvider, createAssetModelServiceProvider } from '../../../../../../../../../../providers/asset-provider'
import { toast } from 'react-toastify';

const PADDING_PAGE = 60

const styles = {
  paper: {
    width: `calc(100% - ${(PADDING_PAGE * 2)}px)`,
    padding: 20
  },
  formControl: {
    width: '100%'
  }
}

class AssetModelServiceChangePage extends React.Component {
  constructor (props) {
    super (props)

    this.state = {
      loading: false,
      id: null,
      name: '',
      system: {},
      asset_model: {},
      asset_models: [],
      systems: []
    }
  }

  componentWillMount () {
    this.setState({
      loading: true
    })

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      getAssetModelServiceByIdProvider(this.props.match.params.id)
        .then(item => {
          return Promise.all([
            getAssetModelProvider(),
            getSystemProvider()
          ])
            .then(data => {
              this.setState({
                loading: false,
                asset_models: data[0],
                systems: data[1],
                id: item.id,
                name: item.name,
                system: item.system,
                asset_model: item.asset_model
              })
            })
        })
        .catch(error => {
          console.error('error', error)
  
          this.setState({
            loading: false
          })
        })
    } else {
      Promise.all([
        getAssetModelProvider(),
        getSystemProvider()
      ])
        .then(data => {
          this.setState({
            loading: false,
            asset_models: data[0],
            systems: data[1],
            id: null,
            name: '',
            system: {},
            asset_model: {}
          })
        })
        .catch(error => {
          console.error('error', error)
  
          this.setState({
            loading: false
          })
        })
    }
  }

  render () {
    const {classes} = this.props

    if (this.state.loading) {
      return (
        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            // backgroundColor: grey['100']
            backgroundColor: 'white'
          }}
        >
          <CircularProgress />
          <div
            style={{
              marginTop: 20
            }}
          >
            Loading...
          </div>
        </div>
      )
    }

    return (
      <div
        style={{
          height: '100%',
          width: '100%',
          padding: PADDING_PAGE,
          backgroundColor: grey['100']
        }}
      >
        <Paper
          className={classes.paper}
          elevation={1}
        >
          <form
            onSubmit={e => {
              e.preventDefault()

              if (this.state.name && this.state.system.id && this.state.asset_model.id) {
                this.setState({loading: true})

                if (this.state.id) {
                  updateAssetModelServiceProvider({
                    id: this.state.id,
                    name: this.state.name,
                    system_id: this.state.system.id,
                    asset_model_id: this.state.asset_model.id
                  })
                    .then(() => {
                      this.setState({
                        loading: false
                      })
  
                      toast.success('Success!', {
                        position: "top-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true
                      })
                    })
                    .catch(error => {
                      console.error('updateAssetModelServiceProvider', error)
                      this.setState({
                        loading: false
                      })
                      toast.error('Save error', {
                        position: "top-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true
                      })
                    })
                } else {
                  createAssetModelServiceProvider({
                    name: this.state.name,
                    system_id: this.state.system.id,
                    asset_model_id: this.state.asset_model.id
                  })
                    .then(() => {
                      this.setState({
                        loading: false,
                        name: '',
                        system: {},
                        asset_model: {}
                      })
  
                      toast.success('Success!', {
                        position: "top-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true
                      })
                    })
                    .catch(error => {
                      console.error('createAssetModelServiceProvider', error)
                      this.setState({
                        loading: false
                      })
  
                      toast.error('Save error', {
                        position: "top-right",
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true
                      })
                    })
                }
              } else {
                toast.error('Invalid params', {
                  position: "top-right",
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true
                })
              }
            }}
          >
            <FormControl
              className={classes.formControl}
            >
              <InputLabel
                htmlFor="age-simple"
              >
                System
              </InputLabel>
              <Select
                value={this.state.system}
                onChange={(e) => this.setState({system: e.target.value})}
                renderValue={value => {
                  if (!value) {
                    return 'None'
                  }

                  return `${value.name}`
                }}
              >
                {
                  this.state.systems.map((system, indexSystem) => {
                    return (
                      <MenuItem
                        key={indexSystem}
                        value={system}
                      >
                        {system.name}
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>

            <FormControl
              className={classes.formControl}
            >
              <InputLabel
                htmlFor="age-simple"
              >
                Asset model
              </InputLabel>
              <Select
                value={this.state.asset_model}
                onChange={(e) => this.setState({asset_model: e.target.value})}
                renderValue={value => {
                  if (!value) {
                    return 'None'
                  }

                  return `${value.name}`
                }}
              >
                {
                  this.state.asset_models.map((asset_model, indexSystem) => {
                    return (
                      <MenuItem
                        key={indexSystem}
                        value={asset_model}
                      >
                        {asset_model.name}
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>

            <TextField
              label="Name"
              className={classes.textField}
              value={this.state.name}
              onChange={e => this.setState({name: e.target.value})}
              style={{
                width: '100%'
              }}
            />

            <div
              style={{
                position: 'fixed',
                right: 20,
                bottom: 10
              }}
            >
              <Button
                variant='fab'
                color="primary"
                type='submit'
              >
                <Send />
              </Button>
            </div>
          </form>
        </Paper>
      </div>
    )
  }
}

export default withStyles(styles)(AssetModelServiceChangePage)
